export const LOAD_COUNTRIES = '[COMMON] LOAD_COUNTRIES'
export const LOAD_INSTRUMENTS = '[COMMON] LOAD_INSTRUMENTS'
export const CHANGE_LOADER = '[COMMON] CHANGE_LOADER'
export const CHANGE_POINTS = '[COMMON] CHANGE_POINTS'
